document.addEventListener('DOMContentLoaded', () => {
	// Initialize Wow.js library
	// eslint-disable-next-line
	const wow = new WOW({
		animateClass: 'animate__animated',
	}).init();

	// Initialize Fancybox library
	// eslint-disable-next-line
	Fancybox.bind('[data-fancybox]', {});

	const getBooleanValue = (value) => value === 'true';

	const body = document.querySelector('body');
	const header = document.querySelector('#header');
	const nav = document.querySelector('#navigation');

	nav.querySelector('#navigation-toggle').addEventListener('click', () => {
		const value = !getBooleanValue(nav.dataset.open);
		nav.dataset.open = value;
		body.dataset.overlay = value;
	});

	document.addEventListener('click', (event) => {
		if (!header.contains(event.target)) {
			nav.dataset.open = false;
			body.dataset.overlay = false;
		}
	});

	nav.querySelectorAll('a').forEach((navItem) => {
		navItem.addEventListener('click', () => {
			nav.dataset.open = false;
		});
	});
});
